module.exports = __webpack_public_path__ + "img/icon-phone.320bc6f1.svg";